import api from './api';

// Auth API functions
export const getCurrentUser = async () => {
  try {
    const response = await api.get('/auth/user', {
      withCredentials: true
    });
    return response.data;
  } catch (error) {
    // L'interceptor gère déjà les redirections OAuth
    // Ici on gère seulement les vraies erreurs réseau
    console.log('User not authenticated or network error:', error.message);
    return { authenticated: false };
  }
};

export const trackNodeVisit = async (nodeId, actionType = 'VIEW') => {
  try {
    const response = await api.post(`/auth/track/${nodeId}`, null, {
      params: { actionType },
      withCredentials: true
    });
    return response.data;
  } catch (error) {
    console.error('Failed to track node visit:', error);
    throw error;
  }
};

export const toggleBookmark = async (nodeId) => {
  try {
    const response = await api.post(`/auth/bookmark/${nodeId}`, null, {
      withCredentials: true
    });
    return response.data;
  } catch (error) {
    console.error('Failed to toggle bookmark:', error);
    throw error;
  }
};

export const getUserBookmarks = async () => {
  try {
    const response = await api.get('/auth/bookmarks', {
      withCredentials: true
    });
    return response.data;
  } catch (error) {
    console.error('Failed to get user bookmarks:', error);
    throw error;
  }
};

export const getUserJourney = async () => {
  try {
    const response = await api.get('/auth/journey', {
      withCredentials: true
    });
    return response.data;
  } catch (error) {
    console.error('Failed to get user journey:', error);
    throw error;
  }
};

export const getUserStats = async () => {
  try {
    const response = await api.get('/auth/stats', {
      withCredentials: true
    });
    return response.data;
  } catch (error) {
    console.error('Failed to get user stats:', error);
    throw error;
  }
};

export const checkBookmarkStatus = async (nodeId) => {
  try {
    const response = await api.get(`/auth/check/${nodeId}`, {
      withCredentials: true
    });
    return response.data;
  } catch (error) {
    console.error('Failed to check bookmark status:', error);
    return { bookmarked: false };
  }
};

export const rateNode = async (nodeId, rating, comment = null) => {
  try {
    const params = new URLSearchParams({ rating });
    if (comment) {
      params.append('comment', comment);
    }
    
    const response = await api.post(`/auth/rate/${nodeId}`, null, {
      params,
      withCredentials: true
    });
    return response.data;
  } catch (error) {
    console.error('Failed to rate node:', error);
    throw error;
  }
};

export const getUserRating = async (nodeId) => {
  try {
    const response = await api.get(`/auth/rating/${nodeId}`, {
      withCredentials: true
    });
    return response.data;
  } catch (error) {
    console.error('Failed to get user rating:', error);
    return { nodeId, rating: null };
  }
};

export const getUserRatings = async () => {
  try {
    const response = await api.get('/auth/ratings', {
      withCredentials: true
    });
    return response.data;
  } catch (error) {
    console.error('Failed to get user ratings:', error);
    throw error;
  }
};

export const getNodeRatingStats = async (nodeId) => {
  try {
    const response = await api.get(`/auth/node/${nodeId}/stats`, {
      withCredentials: true
    });
    return response.data;
  } catch (error) {
    console.error('Failed to get node rating stats:', error);
    return { nodeId, hasRated: false };
  }
};

// Revealed cards API functions
export const getUserReveals = async () => {
  try {
    const response = await api.get('/auth/reveals/all', {
      withCredentials: true
    });
    return response.data;
  } catch (error) {
    console.error('Failed to get user reveals:', error);
    return { revealed: [] };
  }
};

export const revealNode = async (nodeId) => {
  try {
    const response = await api.post(`/auth/reveal/${nodeId}`, null, {
      withCredentials: true
    });
    return response.data;
  } catch (error) {
    console.error('Failed to reveal node:', error);
    throw error;
  }
};

export const getUserSolutions = async () => {
  try {
    const response = await api.get('/auth/solutions', { withCredentials: true });
    return response.data;
  } catch (error) {
    console.error('Failed to get user solutions:', error);
    return { solutions: [] };
  }
};

export const setUserSolutions = async (solutions) => {
  try {
    const response = await api.post('/auth/solutions', { solutions }, { withCredentials: true });
    return response.data;
  } catch (error) {
    console.error('Failed to set user solutions:', error);
    throw error;
  }
};

export const getCommunitySolutions = async () => {
  try {
    const response = await api.get('/solutions/community');
    return response.data;
  } catch (error) {
    console.error('Failed to get community solutions:', error);
    return { combinations: [] };
  }
};
